import { Link } from "react-router-dom";

type RequestIdLinkProps = {
  // The underlying leave request's id (for cancellations, pass
  // originalRequestId, not the cancellation record's own id).
  id: number;
  // Cancellation rows link through /review-cancellation instead of /review -
  // same view today, but keeps the route semantically distinct.
  cancellation?: boolean;
};

// Same destination the "Request ID" field already links to in notification
// emails (see LeaveRequestNotificationService#requestViewUrl) - ?view=1
// forces LeaveRequestView into read-only mode (no Approve/Reject) since this
// is just a "look up a request" affordance from a list, not an action queue.
export const RequestIdLink = ({ id, cancellation }: RequestIdLinkProps) => (
  <Link
    to={`/${cancellation ? "review-cancellation" : "review"}/${id}?view=1`}
    target="_blank"
    rel="noreferrer"
    onClick={(e) => e.stopPropagation()}
  >
    #{id}
  </Link>
);

export default RequestIdLink;
